export default "/images/framework/ToWebCht.844ba6dc.svg?844ba6dc";